<template>
  <transition name="el-fade-in">
    <div class="banner-cropper">
      <div class="mask" @click="cancelCrop"></div>
      <Card
        title="调整图片尺寸与位置"
        custom_class="cropper"
        :has_operations="true"
        :header_line="true"
        sub_title="拖拽让图片处在一个合适的裁切位置">
        <template slot="operations">
          <el-button
            type="primary"
            size="small"
            plain
            @click="cancelCrop">取消
          </el-button>
          <el-button
            type="primary"
            @click="cropBanner"
            :loading="uploading_banner"
            size="small" >上 传
          </el-button>
        </template>
        <div class="banner-wrapper"
            :class="{'loading':loading}"
            v-loading="loading">
          <div class="cropper-wrapper"
            ref="wrapper"
            :style="`height: ${this.containerHeight}px`">
            <vue-cropper
            ref="cropper"
            :src="image_url"
            :modal="false"
            :center="false"
            :aspectRatio="aspectRatio"
            :cropBoxMovable="false"
            :cropBoxResizable="false"
            :autoCrop="true"
            :guides="false"
            :background="true"
            :highlight="false"
            :minCropBoxWidth="minCropBoxWidth"
            :minCropBoxHeight="minCropBoxHeight"
            dragMode="move"
            :ready="onCropperReady"
            ></vue-cropper>
          </div>
          <div class="zoomer">
            <span class="zoomer-text">缩放图片</span>
            <i class="icon-g-picture-outline iconfont smaller"></i>
            <el-slider class="zoomer-slider" v-model="zoomRatio" :format-tooltip="formatZoomerTooltip"></el-slider>
            <i class="icon-g-picture-outline iconfont bigger"></i>

            <a class="change-custom"
              href="javascript:void(0)" @click="chooseBanner"><i class="iconfont icon-g-picture"></i>重新上传图片</a>
          </div>
        </div>
      </Card>
    </div>
  </transition>
</template>

<script>
import Card from '@/components/BackdropCropper/el-card'
import VueCropper from 'vue-cropperjs'
export default {
  data () {
    return {
      aspectRatio: 1440 / 280,
      zoomRatio: 50,
      containerData: null,
      minCropBoxWidth: 0,
      minCropBoxHeight: 0,
      containerHeight: 200,
      loading: true,
      uploading_banner: false
    }
  },
  components: {
    Card,
    VueCropper
  },
  props: {
    image_url: {
      type: String,
      default: ''
    },
    uploadBanner: {
      type: Function,
      required: true
    }
  },
  computed: {
    cropper () {
      return this.$refs.cropper
    },
    gid () {
      return this.$store.getters.group_id
    }
  },
  watch: {
    zoomRatio () {
      this.zoom(this.zoomRatio)
    },
    image_url () {
      this.cropper.replace(this.image_url)
    }
  },
  methods: {
    cancelCrop () {
      this.$emit('cancel')
    },
    realTime () {

    },
    zoom (val) {
      if (!this.containerData) {
        this.containerData = this.cropper.getContainerData()
      }
      this.cropper.zoomTo((val - 50 + 100) / 100, {
        x: this.containerData.width / 2,
        y: this.containerData.height / 2
      })
    },
    formatZoomerTooltip (val) {
      return (val - 50 + 100) + '%'
    },
    onCropperReady () {
      this.loading = false
      this.containerData = this.cropper.getContainerData()
      const props = {
        left: 0,
        top: 0,
        width: this.containerData.width,
        height: this.containerData.height
      }
      this.cropper.setCropBoxData(props)
      this.cropper.setCanvasData(props)
    },
    cropBanner () {
      const canvas = this.cropper.getCroppedCanvas()
      this.uploading_banner = true
      canvas.toBlob((blob) => {
        this.uploadBanner(blob).then((url) => {
          this.$emit('cropped', url)
          this.uploading_banner = false
        }).catch((e) => {
          this.uploading_banner = false
          this.$message({
            type: 'error',
            message: '上传失败，请稍后再试'
          })
        })
      })
    },
    chooseBanner () {
      const btn = document.getElementById('upload-banner')
      btn.click()
    }
  },
  mounted () {
    this.containerHeight = this.$refs.wrapper.offsetWidth / this.aspectRatio
    this.minCropBoxHeight = this.containerHeight
    this.minCropBoxWidth = this.$refs.wrapper.offsetWidth
  }
}
</script>

<style scoped>
  .banner-cropper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
  }
  .mask {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.2);
  }
  .cropper {
    position: relative;
    top: 50%;
    width: 1210px;
    margin: 0 auto;
    transform: translateY(-50%);
  }
  .banner-wrapper {
    padding-top: 20px;
  }
  .cropper-wrapper {
    overflow: hidden;
  }
  .banner-wrapper.loading .cropper-wrapper{
    opacity: 0;
  }
  .zoomer {
    margin-top: 5px;
    position: relative;
  }
  .zoomer-slider {
    width: 200px;
    display: inline-block;
    vertical-align: middle;
  }
  .zoomer-text {
    color: #606266;
  }
  .smaller {
    font-size: 15px;
    color: #C0C4CC;
  }
  .bigger {
    font-size: 24px;
    color: #C0C4CC;
    vertical-align: middle;
  }
  .change-custom {
    position: absolute;
    right: 0;
    top: 0;
    line-height: 38px;
  }
  .change-custom:hover {
    text-decoration: none;
  }
  .change-custom i {
    vertical-align: middle;
    margin-right: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/BackdropCropper/el-banner-cropper.vue